exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-text,\n.nav-link,\n.nav-group-content,\n.nav-group-trigger {\n  height: 24px !important;\n  line-height: 24px; }\n\n.clr-vertical-nav {\n  width: 320px !important;\n  padding-top: 12px;\n  height: calc(100vh - 108px) !important;\n  display: block !important;\n  overflow-y: scroll;\n  padding-bottom: 15px; }\n\n.resName {\n  display: inline-block;\n  width: 50%; }\n\n.perSec {\n  width: 25%;\n  display: inline-block; }\n\n.unit-group {\n  margin-left: -28px !important; }\n\n.experience {\n  margin-left: 30px !important; }\n\n.clr-treenode-link {\n  height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/src/app/main-nav/main-nav.component.scss
// module id = ../../../../../src/app/main-nav/main-nav.component.scss
// module chunks = 1